const INVALID_CHARS = ['e', 'E', '+', '-'];

// eslint-disable-next-line new-cap
export const webLibSdk = new window.webLib();
window.webLib = null;

export const trimmedAddress = (address, startCount = 5, endCount = 4) => {
    const start = address.slice(0, startCount);
    const end = address.slice(address.length - endCount, address.length);
    return `${start}...${end}`;
};

export const validateEmail = (email) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    .test(
        email,
    );

export const getCurrentTimeZoneDate = (date) => new Date(new Date(date).getTime() - (new Date(date).getTimezoneOffset() * 2) * 60000).toISOString().replace(/T/, ' ').replace(/\..+/, '')
    .replace(/-/g, '/');

export const findPercentageOfTwo = (num1, num2) => (num1 / num2) * 100;

export const blockInvalidChar = (e) => INVALID_CHARS.includes(e.key) && e.preventDefault();

export const formatPrice = (amount) => new Intl.NumberFormat().format(amount);

export const getFormatterAllocationType = (type) => {
    const isPrivateSale = type.toLowerCase().includes('private');

    if (!isPrivateSale) {
        return type;
    }

    const phase = type.split('')[type.length - 1];

    return `Private Sale ${phase}`;
};

export const normalizeNumber = (number, precision = 4, isString = false) => {
    try {
        let isNegative = false;
        if (number < 0) {
            number = Math.abs(number);
            isNegative = true;
        }

        if (Number(`0.${'0'.repeat(precision - 1)}1`) > Number(number)) {
            return !isString ? 0 : '0';
        }
        if (isNegative) {
            const floatNum = Math.floor(Math.abs(number) * (10 ** precision)) / (10 ** precision);
            return !isString ? -floatNum : -floatNum.toString();
        }
        const floatNum = Math.floor(number * (10 ** precision)) / (10 ** precision);
        return !isString ? floatNum : floatNum.toString();
    } catch (error) {
        console.log(error);
    }
    return number;
};

export const getPlural = (count, text) => (count > 1 ? `${text}s` : text);
